<template>
  <ux-form
    class="debugg x-border-50 x-margin x-height-100 x-scrollbar-show"
    ref="form"
    :colon="true"
    :hideClose="true"
    :confirmText="$t('HT.options.env2')"
    :data="formData"
    :rules="rules"
    @confirm="confirm"
    label-width="100px"
    data-automation="debugg"
  >
    <!-- 选择API分组 start -->
    <ux-form-item :label="$t('HT.debug1.apiGroup')" required prop="apiGroup" :option="false">
      <my-select
        @change="getSomeUrl"
        class="input-width"
        v-model="formData.apiGroup"
        :list="apiGroupList"
        label="name"
        value="id"
        :popper-append-to-body="false"
      ></my-select>
    </ux-form-item>
    <!-- 选择API分组 end -->

    <!-- 选择API start -->
    <ux-form-item v-if="apiGroup" :label="$t('HT.debug1.apiId')" required prop="apiId">
      <my-select
        class="input-width"
        v-model="formData.apiId"
        :list="apiList"
        label="name"
        value="id"
        :popper-append-to-body="false"
      ></my-select>
    </ux-form-item>
    <!-- 选择API end -->

    <!-- 选择环境 start -->
    <ux-form-item
      v-if="info.group && info.group.domains"
      :label="$t('HT.accessInfo.env.placeholder')"
      required
      prop="env"
    >
      <my-select
        class="input-width"
        v-model="formData.env"
        :list="envList"
        value="env"
        :popper-append-to-body="false"
        @change="getEnv"
      ></my-select>
    </ux-form-item>
    <!-- 选择环境 end -->
    <!-- 方法和域名 start -->
    <ux-form-item
      v-if="info.group && info.group.domains"
      :label="$t('HT.debug1.domains')"
      labelWidth="88px"
      required
      prop="domain"
      :option="false"
    >
      <span class="info-method">{{ info.request.method }}</span>
      <span class="info-protocol">{{ info.protocol }}://</span>
      <my-select
        @change="getDomainInfo"
        class="input-width"
        v-model="formData.domain"
        :list="domainUrl"
        value="domain"
        label="domain"
        :popper-append-to-body="false"
      ></my-select>
      <span class="info-protocol">{{ info.uri }}</span>
    </ux-form-item>
    <!-- 方法和域名 end -->

    <!-- 安全认证 start -->
    <ux-form-item
      v-if="info.group && info.group.domains"
      :label="$t('HT.debug1.safety')"
      required
      prop="safety.type"
    >
      <my-select
        v-model="formData.safety.type"
        label="label"
        value="value"
        :list="$opt.debugSafeList"
        :popper-append-to-body="false"
        @change="onchange"
      ></my-select>
    </ux-form-item>

    <template v-if="formData.safety.type !== 'NONE' && formData.safety.type == 'EASY'">
      <ux-form-item label="AppCode" :option="false" prop="safety.AppCode">
        <ux-input
          class="safe-input"
          v-model="formData.safety.AppCode"
          size="small"
          maxlength="50"
          :placeholder="$t('HT.pleaseInput')"
        ></ux-input>
      </ux-form-item>
    </template>
    <template v-if="formData.safety.type == 'ALL'">
      <ux-form-item label="AppKey" :option="false" prop="safety.AppKey">
        <ux-input
          class="safe-input"
          v-model="formData.safety.AppKey"
          size="small"
          maxlength="50"
          :placeholder="$t('HT.pleaseInput')"
        ></ux-input>
      </ux-form-item>
      <ux-form-item label="AppSecret" :option="false" prop="safety.AppSecret">
        <ux-input
          class="safe-input"
          v-model="formData.safety.AppSecret"
          size="small"
          maxlength="50"
          :placeholder="$t('HT.pleaseInput')"
        ></ux-input>
      </ux-form-item>
    </template>
    <!-- 安全认证 end -->

    <!-- Path  start-->
    <ux-form-item
      v-if="info.request && info.request.parameters && pathCount > 0"
      label="Path"
      start
    >
      <div v-for="(item, index) in info.request.parameters" class="item-requst">
        <div
          class="x-flex-align input-width x-margin-b"
          v-if="item.position === 'Path'"
          :key="index"
        >
          <ux-input v-model="info.request.parameters[index].name" size="small" readonly></ux-input>
          <span class="x-margin-x">=</span>
          <ux-input
            v-model="path[item.name]"
            size="small"
            :placeholder="item.required ? $t('HT.required') : ''"
          ></ux-input>
        </div>
      </div>
    </ux-form-item>
    <!-- Path  end-->

    <!-- Header start-->
    <ux-form-item
      v-if="
        info.request &&
        info.request.parameters &&
        info.request.transfer_type != 'PASS_THROUGH' &&
        headerCount > 0
      "
      label="Header"
      start
    >
      <div v-for="(item, index) in info.request.parameters" class="item-requst">
        <div
          class="x-flex-align input-width x-margin-b"
          v-if="item.position === 'Header'"
          :key="index"
        >
          <ux-input v-model="info.request.parameters[index].name" size="small" readonly></ux-input>
          <span class="x-margin-x">=</span>
          <ux-input
            v-model="header[item.name]"
            size="small"
            :placeholder="item.required ? $t('HT.required') : ''"
          ></ux-input>
        </div>
      </div>
    </ux-form-item>
    <!-- Header end-->

    <!-- Header 透传处理  start-->
    <ux-form-item
      v-if="info.request && info.request.transfer_type === 'PASS_THROUGH'"
      label="Header"
      start
      class="item-option"
    >
      <div v-for="(item, index) in formData.mapping.Header" class="item-requst">
        <div class="x-flex-align input-width x-margin-b" :key="index">
          <ux-input v-model="formData.mapping.Header[index]" size="small"></ux-input>
          <span class="x-margin-x">=</span>
          <ux-input v-model="header[formData.mapping.Header[index]]" size="small"></ux-input>
          <ux-button
            class="add-button"
            v-if="index == 0"
            type="primary"
            size="small"
            @click="addHeaders"
            >+</ux-button
          >
          <ux-button
            class="add-button"
            v-else
            type="primary"
            size="small"
            @click="delHeaders(index)"
            >-</ux-button
          >
        </div>
      </div>
    </ux-form-item>
    <!-- Header 透传处理  end-->
    <!-- Query start-->
    <ux-form-item
      v-if="
        info.request &&
        info.request.parameters &&
        info.request.transfer_type != 'PASS_THROUGH' &&
        queryCount > 0
      "
      label="Query"
      start
      class="item-option"
    >
      <div v-for="(item, index) in info.request.parameters" class="item-requst-query">
        <div
          class="x-flex-align input-width x-margin-b"
          v-if="item.position === 'Query'"
          :key="index"
        >
          <ux-input v-model="info.request.parameters[index].name" size="small" readonly></ux-input>
          <span class="x-margin-x">=</span>
          <ux-input
            v-model="query[item.name]"
            size="small"
            :placeholder="item.required ? $t('HT.required') : ''"
          ></ux-input>
        </div>
      </div>
    </ux-form-item>
    <!-- Query end-->
    <!-- Query 透传处理  start-->
    <ux-form-item
      v-if="info.request && info.request.transfer_type === 'PASS_THROUGH'"
      label="Query"
      start
      class="item-option"
    >
      <div v-for="(item, index) in formData.mapping.Query" class="item-requst-query">
        <div class="x-flex-align input-width x-margin-b" :key="index">
          <ux-input v-model="formData.mapping.Query[index]" size="small"></ux-input>
          <span class="x-margin-x">=</span>
          <ux-input v-model="query[formData.mapping.Query[index]]" size="small"></ux-input>
          <ux-button
            class="add-button"
            v-if="index == 0"
            type="primary"
            size="small"
            @click="addQuerys"
            >+</ux-button
          >
          <ux-button class="add-button" v-else type="primary" size="small" @click="delQuerys(index)"
            >-</ux-button
          >
        </div>
      </div>
    </ux-form-item>
    <!-- Query 透传处理  end-->

    <ux-form-item :label="$t('HT.debug1.reponse')" start prop="reponse">
      <ux-input
        v-model="response"
        type="textarea"
        size="small"
        readonly
        :autosize="{ minRows: 15, maxRows: 15 }"
      ></ux-input>
    </ux-form-item>
    <!-- <my-footer-btn spacing="80px" padding="10px" hideClose confirmText="测 试" @confirm="confirm"></my-footer-btn> -->
  </ux-form>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        apiId: '', // API id
        env: '', // 环境
        apiGroup: '', //API分组
        domain: '', //域名列表

        safety: {
          type: '',
          AppCode: '',
          AppKey: '',
          AppSecret: ''
        }, //选择认证
        params: {
          Path: '',
          Header: '',
          Query: ''
        },

        mapping: {
          Path: '',
          Header: '',
          Query: ''
        }
      },
      path: {}, // 发送参数
      header: {}, // 发送参数
      query: {}, // 发送参数
      apiList: [], // API列表
      envList: [], // 可选环境
      info: {}, // API 详情
      response: '', // 响应
      type: '', // 根据开发和用户获取不同接口
      apiGroupList: [], //api分组
      rules: this.$rul.testApi(),
      headContent: '', //header内容
      headType: '', //header类型
      headerList: [1],
      domainUrl: [], //域名列表
      domainInfo: '', //选中的域名,
      envInfo: '',
      flag: false,
      params: [],
      queryCount: 0,
      headerCount: 0,
      pathCount: 0
      // r1:{},
      // r2:{}
    };
  },

  created() {
    let userData = this.$store.state.login.userData;
    this.type = userData.type == 'FRONT' ? 'service' : 'api';
    // this.getList();
    this.getApigroup();
    this.formData.mapping.Query = this.formData.mapping.Query.split(',');
    this.formData.mapping.Header = this.formData.mapping.Header.split(',');
    this.formData.mapping.Path = this.formData.mapping.Path.split(',');
  },
  methods: {
    /**
     * 添加Querys
     */
    addQuerys() {
      this.formData.mapping.Query.push('');
    },
    /**
     * 添加Header
     */
    addHeaders() {
      this.formData.mapping.Header.push('');
    },
    /**
     * 添加Paths
     */
    addPaths() {
      this.formData.mapping.Path.push('');
    },

    /**
     * 删除Querys
     */
    delQuerys(index) {
      this.formData.mapping.Query.splice(index, 1);
    },
    /**
     * 删除Headers
     */
    delHeaders(index) {
      this.formData.mapping.Header.splice(index, 1);
    },
    /**
     * 删除Paths
     */
    delPaths(index) {
      this.formData.mapping.Path.splice(index, 1);
    },

    getEnv(env) {
      this.envInfo = env;
    },
    // 选择认证
    onchange() {
      if (this.flag) {
        this.flag = false;
        return;
      }
      this.$set(this.formData.safety, 'AppCode', null);
      this.$set(this.formData.safety, 'AppKey', null);
      this.$set(this.formData.safety, 'AppSecret', null);
    },

    // 获取选择的域名
    getDomainInfo(domainString) {
      this.domainInfo = domainString;
    },

    // 点击api分组下拉框数据调用接口获取域名
    getSomeUrl(id) {
      this.$api.group.getInfoList(id).then((res) => {
        if (res.code == 10000) {
          this.domainUrl = [];
          for (let item of res.data.domains) {
            this.domainUrl.push({ domain: item.domain });
          }

          if (res.data.second_domain.domain) {
            this.domainUrl.push({ domain: res.data.second_domain.domain });
          }
        }
      });
    },
    /**
     * 添加header
     */
    addHeader() {
      this.headerList.push(1);
    },
    /**
     * 删除header
     */
    delHeader(index) {
      this.headerList.splice(index, 1);
    },

    getApiInfo(id) {
      this.$api.group.getProductApigroup(id).then((res) => {
        if (res.code == 10000) {
          this.apiList = res.data;
        }
      });
    },
    /**
     * 获取信息
     * @param {String} id 唯一标识
     */
    getInfo(id) {
      this.$uxLoading.show();
      this.$api.service.getInfo(this.type, id).then((res) => {
        if (res.code == 10000) {
          this.info = res.data;
          this.params = res.data.request ? res.data.request.parameters : [];
          let states = res.data.states || [];
          // let domains = res.data.group.domains || [];
          let second_domain = res.data.request ? res.data.group.second_domain.domain : '';
          let result = [];
          for (let i = 0; i < states.length; i++) {
            let env = states[i]['env'];

            result.push({
              env: env,
              label: this.$opt.switchStr(env, this.$opt.env),
              domain: second_domain
            });
          }

          this.envList = result;
        }
      });
    },
    /**
     * Api分组
     */
    getApigroup() {
      this.$api.product.getProductApigroup().then((res) => {
        if (res.code == 10000) {
          this.apiGroupList = res.data;
        }
      });
    },

    /**
     * 方法
     * @param {Array} envList 查询对象
     */
    getDomain(envList) {
      for (let item of envList) {
        if (this.formData.env == item.env) {
          return item;
        }
      }
    },

    /**
     * 测试发送请求
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let config = {
            config: true
          };
          let myquery = {};
          Object.assign(myquery, this.path, this.query, this.header);
          let arr = Object.keys(myquery);
          for (let i of arr) {
            if (i == '') {
              delete myquery[i];
            }
          }
          const postData = {
            url: `${this.info.protocol}://${this.domainInfo}${this.info.uri}`,
            env: this.envInfo,
            domain: this.info.group.second_domain.domain,
            app_code: this.formData.safety.AppCode,
            parameters: myquery
          };
          this.test(postData, this.formData.apiId, config);
        }
      });
    },

    /**
     * API 调试
     * @param {Object} params 参数对象
     * @param {Object} config 请求config
     */
    test(params, apiId, config) {
      this.$uxLoading.show();
      this.$api.api
        .test(params, apiId, config)
        .then((res) => {
          this.response = this.$writeHtml(res);
        })
        .catch((err) => {
          this.response = this.$writeHtml(err.response.data);
        });
    }
  },

  computed: {
    apiId() {
      return this.formData.apiId;
    },
    apiGroup() {
      return this.formData.apiGroup;
    },
    safetyList() {
      return this.formData.safety;
    },
    backheader() {
      return JSON.parse(JSON.stringify(this.formData.mapping.Header));
    },
    backquery() {
      return JSON.parse(JSON.stringify(this.formData.mapping.Query));
    }
  },

  watch: {
    apiId(val) {
      this.formData.env = '';
      this.$nextTick(() => {
        this.$refs['form'].clearValidate([
          'env',
          'header',
          'params',
          'reponse',
          'domain',
          'safety',
          'AppSecret',
          'AppKey',
          'AppCode',
          'Path',
          'Header',
          'Query'
        ]);
      });
      this.formData.apiId = val;
      this.query = {};
      this.path = {};
      this.header = {};
      this.formData.mapping.Header = [''];
      this.formData.mapping.Query = [''];
      this.formData.mapping.Path = [''];
      this.getInfo(val);
      this.response = '';
    },
    apiGroup(id) {
      this.$refs['form'].resetFields();
      this.formData.apiGroup = id;
      this.getApiInfo(id);
    },
    safetyList: {
      handler(val) {
        this.flag = true;
        this.formData.safety = val;
      }
      // deep: true
    },

    backheader: {
      handler(val, old) {
        let res = {};
        for (let i = 0; i < val.length; i++) {
          res[val[i]] = this.header[old[i]];
        }
        this.header = res;
      },
      deep: true
    },
    backquery: {
      handler(val, old) {
        let res = {};
        for (let i = 0; i < val.length; i++) {
          res[val[i]] = this.query[old[i]];
        }
        this.query = res;
      },
      deep: true
    },
    params: {
      handler(val) {
        this.queryCount = this.headerCount = this.pathCount = 0;
        for (let item of val) {
          if (item.position == 'Query') {
            this.queryCount++;
          } else if (item.position == 'Header') {
            this.headerCount++;
          } else if (item.position == 'Path') {
            this.pathCount++;
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.debugg {
  box-sizing: border-box;
  padding: 20px 30px 20px 30px;

  .input-width {
    width: 400px;
  }

  .add-button {
    box-sizing: border-box;
    width: 40px;
    min-width: auto;
    margin-left: 10px;
  }

  .info-method {
    margin-right: 30px;
    color: #777f8f;
  }

  .info-protocol {
    color: #777f8f;
    margin-right: 3px;
  }

  .add-button {
    box-sizing: border-box;
    width: 40px;
    min-width: auto;
    margin-left: 10px;
  }
}
</style>
<style lang="scss">
.right-item {
  flex-wrap: wrap;
  flex: 1;
}

.debugg {
  .select {
    width: 15%;
  }

  .item-requst-query {
    width: 100%;
  }

  .safe-input {
    width: 30%;
  }
}
</style>
